@if ((showSpinner$ | async) || (manualSpinner$ | async)) {
  <div class="spinner-underlay">
    <mat-spinner [mode]="'indeterminate'" class="spinner"></mat-spinner>
  </div>
}
